import { ShotOnTargetAttribute } from '@collector/sportsapi-client-legacy'

import { DetailBaseConfigAttributes } from '../../../../composables/useSportOptions'

export const techniqueOfShotDetailsAttributes: DetailBaseConfigAttributes<ShotOnTargetAttribute>['attributes'] =
  [
    {
      attributeId: ShotOnTargetAttribute.LeftFoot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOnTargetAttribute.Normal,
          ShotOnTargetAttribute.FirstTouch,
          ShotOnTargetAttribute.Volley,
          ShotOnTargetAttribute.DirectFreeKick,
          ShotOnTargetAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotOnTargetAttribute.RightFoot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOnTargetAttribute.Normal,
          ShotOnTargetAttribute.FirstTouch,
          ShotOnTargetAttribute.Volley,
          ShotOnTargetAttribute.DirectFreeKick,
          ShotOnTargetAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotOnTargetAttribute.PowerShot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOnTargetAttribute.Normal,
          ShotOnTargetAttribute.FirstTouch,
          ShotOnTargetAttribute.Volley,
          ShotOnTargetAttribute.DirectFreeKick,
          ShotOnTargetAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotOnTargetAttribute.Chip,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOnTargetAttribute.Normal,
          ShotOnTargetAttribute.FirstTouch,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
  ]
